import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import PropTypes from "prop-types";

import { DashHangingUp } from "../dash-hanging-up";

import { CopyrightFooter } from "@features/ui/copyright-footer";
import { ExternalLink } from "@features/ui/external-link";
import { Tooltip } from "@features/ui/tooltip";
import {
  ANALYTICS_EVENT_TYPES,
  usePublicAnalyticsTracking,
} from "@hooks/use-analytics-tracking";
import { HeaderImage } from "@pages/login/components/header-image";

import cubeImageUrl from "@images/cube.png?url";
import sphereImageUrl from "@images/sphere.png?url";
import torusImageUrl from "@images/torus.png?url";
import headerImageUrl from "@images/trek-logo.medium.v2.png?url";

import "./dash.layout.scss";

export const DashLayout = ({ children, className }) => {
  const trackClickTestNetworkConnectivityLink = usePublicAnalyticsTracking(
    ANALYTICS_EVENT_TYPES.test_network_connectivity_link,
  );

  return (
    <div className={clsx("dash-layout", className)}>
      <div className="dash-container">
        <DashHangingUp />
        <img className="cube-image" src={cubeImageUrl} alt="Cube" />
      </div>
      {children && (
        <div className="content-container">
          <HeaderImage imageUrl={headerImageUrl} />
          {children}
          <Tooltip
            className="network-issue-link-tooltip"
            clickDisabled
            content={
              <div>
                <div>
                  Checks if your network is properly configured to connect to
                  Trek Mobile, Transfr Train, and Trek in VR.
                </div>
                <div>
                  Failed tests indicate your network may be blocking required
                  connections and you should reach out to your network
                  administrator.
                </div>
              </div>
            }
          >
            <div className="network-issue-link">
              <ExternalLink
                href="https://console.managexr.com/network-test/transfr"
                onClick={() => trackClickTestNetworkConnectivityLink()}
              >
                Test Your Network Connectivity
              </ExternalLink>
              <FontAwesomeIcon icon="fa-regular fa-external-link" />
            </div>
          </Tooltip>
          <CopyrightFooter />
        </div>
      )}
      <div className="footer-container">
        <img className="torus-image" src={torusImageUrl} alt="Torus" />
        <img className="sphere-image" src={sphereImageUrl} alt="Sphere" />
      </div>
    </div>
  );
};

DashLayout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

DashLayout.displayName = "DashLayout";
